import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const usePostEclipseTenantsPreviewMutation = ({
	onError,
	onSuccess,
	impersonationContext,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IEclipseTenantsPreviewResponse) => void;
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: Api.IEclipseTenantsPreviewRequest) => {
			return userSession.webServiceHelper.callAsync<Api.IEclipseTenantsPreviewResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'integrations/eclipse/tenants/preview',
				}),
				'POST',
				request
			);
		},
		onError,
		onSuccess,
	});
};
